import React from 'react';
import styled from 'styled-components';
import excelIcon from 'assets/images/icon_excel.png';

const BorderedButton = styled.button`
  all: unset;
  margin-top: 20px;
  position: relative;
  float: right;
  display: block;
  border: 1px solid ${(props) => props.theme.colors.gray};
  color: #000;
  background-color: #fff;
  padding: 5px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  border-radius: 4px;
  text-decoration: none;
  transition: 0.2s all;
  line-height: 23px;

  &:active {
    transform: translateY(3px);
  }
`;
const ExcelIcon = styled.img`
  margin-right: 10px;
`;

function ExportExcelButton(props) {
  return (
    <BorderedButton onClick={props.onClick}>
      <ExcelIcon src={excelIcon} alt="엑셀아이콘" />
      {props.text}
    </BorderedButton>
  );
}

export default ExportExcelButton;
